<template>
  <el-alert
    :type="block.level"
    :closable="false"
    show-icon
    class="notice-block"
  >
    <template #title>
      <span data-testid="ai-chat-notice-title">
        {{ block.title || t(`aichat.main.blocks.notice.${block.level}`) }}
      </span>
    </template>
    <span data-testid="ai-chat-notice-text">{{ block.text }}</span>
  </el-alert>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { NoticeBlock } from '../../types'

/* in-conversation system messages: a refused tool, withheld figures, the platform's safe response; `code` is never shown */
defineProps<{
  block: NoticeBlock
}>()

const { t } = useI18n()
</script>

<style scoped>
.notice-block {
  align-self: flex-start;
  max-width: 88%;
}
</style>
